import React, { useState, useEffect, useCallback } from "react";
import { getJudgeName } from "../../utils";

const Phase2 = (props) => {
  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetRecurrence = props.handleSetRecurrence
  const handleSetPhase = props.handleSetPhase
  const handleSetJudge = props.handleSetJudge
  const handleSetJudgeId = props.handleSetJudgeId
  const handleJudgeCreated = props.handleJudgeCreated

  const [countdownSecond, setCountdownSecond] = useState(10);

  const handleSetNextJudge = useCallback(
    () => {
      console.log("props.gameParticipants", props.gameParticipants);
      if (props.gameParticipants.length === 0) {
          return;
      }

      console.log("props.gameParticipants", props.gameParticipants)

      let judgeCandidates = props.gameParticipants
      const initialJudgeCount = props.gameJudges.length
      for (let i = 0; i < judgeCandidates.length; i++) {
        for (let j = 0; j < props.gameJudges.length; j++) {
          console.log("judgeCandidates[i]", judgeCandidates[i])
          console.log("props.gameJudges[j]", props.gameJudges[j])
          console.log("judgeCandidates[i][\"$id\"]", judgeCandidates[i]["$id"])
          if (judgeCandidates[i]["$id"] === props.gameJudges[j]["ParticipantID"] &&
            props.gameJudges[j]["Recurrence"] === props.recurrence) {
            judgeCandidates.splice(i, 1);
          }
        }
      }
      if (initialJudgeCount > 0 && judgeCandidates.length === 0) {
        handleSetRecurrence(props.recurrence + 1);
        judgeCandidates.append(props.gameParticipants[0])
      }

      handleSetJudgeId(judgeCandidates[0]["$id"]);
      handleSetJudge(judgeCandidates[0]);
      handleJudgeCreated(props.gameCode, judgeCandidates[0]["$id"], judgeCandidates[0]["Name"], props.recurrence);
      handleGameStateChanged({ newJudge: judgeCandidates[0]["$id"] });

    }, [
      props.gameParticipants,
      props.gameJudges,
      props.gameCode,
      props.recurrence,
      handleSetJudgeId,
      handleSetJudge,
      handleJudgeCreated,
      handleGameStateChanged,
      handleSetRecurrence,
    ]
  );

  const loadJudge = useCallback(() => {
    return (
      <h1 className="text-4xl font-bold text-center text-black">
        {getJudgeName(props.judge["Name"], props.gameState, props.gameParticipants)}
      </h1>
    )
  }, [props.judge, props.gameState, props.gameParticipants]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.gameState?.JudgeID !== "" &&
        props.gameState?.JudgeID !== undefined && props.gameState?.JudgeID !== null) {
        setCountdownSecond(countdownSecond - 1);
        if (countdownSecond <= 1) {
          handleGameStateChanged({ newPhase: 3 });
          clearTimeout(timer)
        }
      } else if (props.gameParticipants.length > 0) {
        handleSetNextJudge();
      }
    }, 1000);
  }, [countdownSecond, props.gameState, props.gameParticipants, handleSetNextJudge, handleGameStateChanged]);

  return (
    <div className="mt-[15%] mx-5 border border-black rounded-xl grid place-items-center">
      <div className="p-[10%]">
        {loadJudge()}
      </div>

      <div className="my-[10%]">
        <h3 className="text-gray-950">Your turn to be the judge</h3>
      </div>

      <h3 className="text-gray-950 text-xl">Get ready... <span className="font-bold text-xl">{countdownSecond}</span></h3>
    </div>
  )
}

export default Phase2;
